var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkColorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VK.com-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.1733 4H24.8267C35.4667 4 38 6.53333 38 17.1733V28.8267C38 39.4667 35.4667 42 24.8267 42H13.1733C2.53333 42 0 39.4667 0 28.8267V17.1733C0 6.53333 2.53333 4 13.1733 4Z",
    fill: "#5181B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M31.1193 17.0915C31.2953 16.5044 31.1193 16.073 30.2813 16.073H27.5105C26.806 16.073 26.4812 16.4457 26.305 16.8566C26.305 16.8566 24.8959 20.2912 22.8998 22.5222C22.254 23.1679 21.9604 23.3734 21.6082 23.3734C21.4321 23.3734 21.1771 23.1679 21.1771 22.5809V17.0915C21.1771 16.387 20.9727 16.073 20.3855 16.073H16.0313C15.5911 16.073 15.3263 16.4 15.3263 16.7099C15.3263 17.3778 16.3243 17.5318 16.4272 19.4105V23.4909C16.4272 24.3855 16.2656 24.5477 15.9133 24.5477C14.974 24.5477 12.6891 21.0978 11.3339 17.1502C11.0683 16.3829 10.802 16.073 10.0938 16.073H7.32299C6.53133 16.073 6.37299 16.4457 6.37299 16.8566C6.37299 17.5905 7.31236 21.2306 10.7469 26.0448C13.0365 29.3325 16.2625 31.1147 19.198 31.1147C20.9593 31.1147 21.1772 30.7188 21.1772 30.037V27.5522C21.1772 26.7605 21.344 26.6025 21.9018 26.6025C22.3127 26.6025 23.0172 26.808 24.6611 28.3932C26.5399 30.2719 26.8496 31.1147 27.9063 31.1147H30.6772C31.4688 31.1147 31.8647 30.7188 31.6363 29.9377C31.3864 29.1591 30.4894 28.0296 29.2992 26.6906C28.6534 25.9273 27.6847 25.1054 27.3911 24.6944C26.9802 24.1661 27.0976 23.9312 27.3911 23.4615C27.3911 23.4615 30.767 18.706 31.1193 17.0915Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkColorLight);
export default __webpack_public_path__ + "static/media/vk-color-light.21d6af0d748ed6d7c8ce4dd9377ddf34.svg";
export { ForwardRef as ReactComponent };